var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.1385 2.29633C11.6899 2.06789 12.3094 2.06789 12.8608 2.29633L19.409 5.00923C20.1849 5.33068 20.7473 6.07313 20.7701 6.95597C20.8871 11.5013 19.4296 17.7631 13.067 21.5139C12.4101 21.9012 11.5955 21.9047 10.9353 21.5237C4.43153 17.7707 3.09402 11.4935 3.22752 6.95318C3.2534 6.07287 3.81392 5.33089 4.59034 5.00922L11.1385 2.29633ZM11.9999 7.0595C10.2197 7.0595 8.77646 8.5027 8.77646 10.283C8.77646 11.3677 9.31227 12.3273 10.1337 12.9116V13.5769C10.1337 14.6077 10.9692 15.4432 11.9999 15.4432C13.0307 15.4432 13.8662 14.6077 13.8662 13.5769V12.9116C14.6876 12.3273 15.2234 11.3677 15.2234 10.283C15.2234 8.5027 13.7802 7.0595 11.9999 7.0595Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77734 10.283C8.77734 8.50277 10.2205 7.05957 12.0008 7.05957C13.7811 7.05957 15.2243 8.50277 15.2243 10.283C15.2243 11.3678 14.6885 12.3274 13.8671 12.9116V13.577C13.8671 14.6077 13.0315 15.4433 12.0008 15.4433C10.9701 15.4433 10.1345 14.6077 10.1345 13.577V12.9116C9.31315 12.3274 8.77734 11.3678 8.77734 10.283Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoShield);
export default __webpack_public_path__ + "static/media/DuoShield.e65d1087b6a320c32187bd9da78177de.svg";
export { ForwardRef as ReactComponent };